import React from 'react';
import { Clock, HelpCircle, Search, FileText, Home, MessageCircle } from 'lucide-react';

/* Six independent chip categories — keys are the backend `category` values. Never merge. */
export const TABS = [
  { key: 'pending',              label: 'Tax Pending',          icon: Clock },
  { key: 'clarification',        label: 'Tax Clarification',    icon: HelpCircle },
  { key: 'search_pending',       label: 'Search Pending',       icon: Search },
  { key: 'search_clarification', label: 'Search Clarification', icon: FileText },
  { key: 'mls_pending',          label: 'MLS Pending',          icon: Home },
  { key: 'mls_clarification',    label: 'MLS Clarification',    icon: MessageCircle },
];

export const TAB_COLORS = {
  pending:              { accent: '#f59e0b', soft: '#fffbeb', border: '#fde68a', text: '#92400e', tile: '#fef3c7' },
  clarification:        { accent: '#3b82f6', soft: '#eff6ff', border: '#bfdbfe', text: '#1e40af', tile: '#dbeafe' },
  search_pending:       { accent: '#0ea5e9', soft: '#f0f9ff', border: '#bae6fd', text: '#0c4a6e', tile: '#e0f2fe' },
  search_clarification: { accent: '#6366f1', soft: '#eef2ff', border: '#c7d2fe', text: '#3730a3', tile: '#e0e7ff' },
  mls_pending:          { accent: '#10b981', soft: '#ecfdf5', border: '#a7f3d0', text: '#065f46', tile: '#d1fae5' },
  mls_clarification:    { accent: '#ec4899', soft: '#fdf2f8', border: '#fbcfe8', text: '#9d174d', tile: '#fce7f3' },
};

export const PLACEHOLDER_HINTS = [
  { tag: '{jurisdiction_name}', desc: 'Jurisdiction name' },
  { tag: '{phone_suffix}', desc: 'Phone' },
  { tag: '{email_suffix}', desc: 'Email' },
  { tag: '{fax_suffix}', desc: 'Fax' },
  { tag: '{county}', desc: 'County' },
  { tag: '{website}', desc: 'Website URL' },
  { tag: '{parcel_apn}', desc: 'Parcel/APN' },
  { tag: '{owner_name}', desc: 'Owner name' },
  { tag: '{tax_year}', desc: 'Tax year' },
];

export const isMlsCategory = (category) => !!category?.startsWith('mls_');

/* Renders template text with {placeholders} as inline tokens */
export function TemplateText({ template, emptyText = 'No template — processor adds a note', className = '' }) {
  if (!template) return <span className={`qc-tpl-empty ${className}`}>{emptyText}</span>;
  const parts = template.split(/(\{[^}]+\})/g);
  return (
    <span className={`qc-tpl ${className}`}>
      {parts.map((part, i) =>
        /^\{[^}]+\}$/.test(part)
          ? <code key={i} className="qc-token">{part}</code>
          : <span key={i}>{part}</span>
      )}
    </span>
  );
}
